import { useCallback, useEffect, useState } from "react";
import { apiService } from "../api/services/apiService";
import type { TenantContactInfo } from "../types";

export function useTenantContactInfo() {
  const [contact, setContact] = useState<TenantContactInfo | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const info = await apiService.getTenantContactInfo();
      setContact(info);
    } catch {
      setContact(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { contact, loading, refresh };
}
